import React from 'react'

function Terms() {
  return (
    <div>
      Terms and Conditions
    </div>
  )
}

export default Terms
